"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OthExpTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  // No questions configured for this area
];

export default function OthExpTailoringQuestions({ onBack }: OthExpTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Expenses"
      title="Other Expenses - Tailoring Questions"
      description="No questions configured for this area."
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}


